/**
 * useSaudacao — port do greetingData() do dashboard.html: saudação por
 * faixa de horário, emoji, mensagem contextual (sorteada, com variante de
 * fim de semana), relógio de 1s e data por extenso em pt-BR.
 */

import { useEffect, useMemo, useState } from 'react'

const MENSAGENS = {
  manha: [
    'Pronto para mais um dia produtivo? ☕',
    'Vamos começar o dia com foco! 🎯',
    'Que tal revisar os processos pendentes? 📋',
  ],
  tarde: [
    'Continue o ótimo trabalho! 💪',
    'Já conferiu suas tarefas de hoje? ✅',
    'Mantenha o ritmo, você está indo bem! 🚀',
  ],
  noite: [
    'Finalizando o dia com eficiência! 🌟',
    'Não esqueça de salvar seu progresso! 💾',
    'Quase lá, continue focado! 🎯',
  ],
  fimDeSemana: [
    'Trabalhando no fim de semana? Você é dedicado! 💼',
    'Aproveite o ritmo tranquilo do fim de semana! 🏖️',
  ],
}

function agoraFormatado() {
  const agora = new Date()
  return {
    hora: agora.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }),
    data: agora.toLocaleDateString('pt-BR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
    }),
  }
}

export function useSaudacao() {
  const [relogio, setRelogio] = useState(agoraFormatado)

  useEffect(() => {
    const timer = setInterval(() => setRelogio(agoraFormatado()), 1000)
    return () => clearInterval(timer)
  }, [])

  // saudação/mensagem fixadas na montagem (não trocam a cada segundo)
  const { saudacao, emoji, mensagem } = useMemo(() => {
    const agora = new Date()
    const hora = agora.getHours()
    const diaDaSemana = agora.getDay()
    const fimDeSemana = diaDaSemana === 0 || diaDaSemana === 6

    let saudacao = 'Boa noite'
    let emoji = '🌙'
    let pool = MENSAGENS.noite
    if (hora >= 5 && hora < 12) {
      saudacao = 'Bom dia'
      emoji = '☀️'
      pool = MENSAGENS.manha
    } else if (hora >= 12 && hora < 18) {
      saudacao = 'Boa tarde'
      emoji = '🌤️'
      pool = MENSAGENS.tarde
    }
    if (fimDeSemana) pool = MENSAGENS.fimDeSemana

    return {
      saudacao,
      emoji,
      mensagem: pool[Math.floor(Math.random() * pool.length)] ?? '',
    }
  }, [])

  return { saudacao, emoji, mensagem, hora: relogio.hora, data: relogio.data }
}
